import {Mapper} from '@s-ui/domain'

/**
 * @implements Mapper
 */
export default class TrackingAppraisalVehicleMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} param
   * @param {Object} param.config
   * @param {Object} param.fromPageTrackingJsonToTrackingDataValueObjectMapper
   */
  constructor({config, fromPageTrackingJsonToTrackingDataValueObjectMapper}) {
    super()

    this._config = config
    this._fromPageTrackingJsonToTrackingDataValueObjectMapper = fromPageTrackingJsonToTrackingDataValueObjectMapper
  }

  /**
   * @param {Object} param
   * @param {String} param.page
   * @param {String} param.culture
   * @param {Object} param.data
   * @param {Object} param.data.title
   */
  map({page, culture, data}) {
    const {title} = data

    const trackingData = {}

    if (title) trackingData.page_category_level2 = title

    return this._fromPageTrackingJsonToTrackingDataValueObjectMapper
      .setParams({
        page,
        culture
      })
      .map(trackingData)
  }
}
